//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { AbstractProgramModel } from '@app/catalog-common';

@Component({
    selector: 'program-item',
    templateUrl: './program-item.component.html',
    styleUrl: './program-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramItemComponent {

    public program = input.required<AbstractProgramModel>();

    constructor() { }    
}
